
import {
  GET_TENSILE_TEST_REQUEST,
  GET_TENSILE_TEST_SUCCESS,
  GET_TENSILE_TEST_FAILURE,
  DELETE_TENSILE_TEST_REQUEST,
  DELETE_TENSILE_TEST_SUCCESS,
  DELETE_TENSILE_TEST_FAILURE,
  CREATE_TENSILE_TEST_REQUEST,
  CREATE_TENSILE_TEST_SUCCESS,
  CREATE_TENSILE_TEST_FAILURE,
  EDIT_TENSILE_TEST_REQUEST,
  EDIT_TENSILE_TEST_SUCCESS,
  EDIT_TENSILE_TEST_FAILURE,
} from "./productTestingTypes";
import axios from "axios";
import Config from "../../config/index";
let baseUrl = Config.baseUrl;

// --- GET API ---
const getTensileTestRequest = () => ({ type: GET_TENSILE_TEST_REQUEST });
const getTensileTestSuccess = (payload) => ({
  type: GET_TENSILE_TEST_SUCCESS,
  payload,
});
const getTensileTestFailure = (error) => ({
  type: GET_TENSILE_TEST_FAILURE,
  payload: error,
});

 const getTensileTest = (dppId, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(getTensileTestRequest());
    let url = dppId
      ? `${baseUrl}/dpp/tensile_test/get_dpp?dppId=${dppId}`
      : `${baseUrl}/dpp/tensile_test/get_all`;

    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getTensileTestSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getTensileTestFailure(err.message));
      });
  };
};

// --- DELETE API ---
const deleteTensileTestRequest = () => ({ type: DELETE_TENSILE_TEST_REQUEST });
const deleteTensileTestSuccess = (payload) => ({
  type: DELETE_TENSILE_TEST_SUCCESS,
  payload,
});
const deleteTensileTestFailure = (error) => ({
  type: DELETE_TENSILE_TEST_FAILURE,
  payload: error,
});

 const deleteTensileTest = (tensileTestId, udBy, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(deleteTensileTestRequest()); 
    let url = `${baseUrl}/dpp/tensile_test/delete?tensileTestId=${tensileTestId}&udBy=${udBy}`;

    return axios
      .delete(url, headers)
      .then((response) => {
        dispatch(deleteTensileTestSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(deleteTensileTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- CREATE API ---
const createTensileTestRequest = () => ({ type: CREATE_TENSILE_TEST_REQUEST });
const createTensileTestSuccess = (payload) => ({
  type: CREATE_TENSILE_TEST_SUCCESS,
  payload,
});
const createTensileTestFailure = (error) => ({
  type: CREATE_TENSILE_TEST_FAILURE,
  payload: error,
});

 const createTensileTest = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(createTensileTestRequest());
    let url = `${baseUrl}/dpp/tensile_test/create`;

    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createTensileTestSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createTensileTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

// --- EDIT API ---
const editTensileTestRequest = () => ({ type: EDIT_TENSILE_TEST_REQUEST });
const editTensileTestSuccess = (payload) => ({
  type: EDIT_TENSILE_TEST_SUCCESS,
  payload,
});
const editTensileTestFailure = (error) => ({
  type: EDIT_TENSILE_TEST_FAILURE,
  payload: error,
});

 const editTensileTest = (payload, jwtToken) => {
  let headers = { headers: { Authorization: `Bearer ${jwtToken}` } };

  return (dispatch) => {
    dispatch(editTensileTestRequest());
    let url = `${baseUrl}/dpp/tensile_test/update`;

    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(editTensileTestSuccess(response));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(editTensileTestFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};



 export {  getTensileTest, deleteTensileTest, createTensileTest, editTensileTest };